import { all } from '../data/all';
import { useParams } from 'react-router-dom';

function CountryFlag() {

    const { country } = useParams();

    let countryData = [];
    
    all.forEach(thisCountry => {
        if (thisCountry.name.common === country) {
            countryData = [thisCountry.name.common, thisCountry.flag];
        }
    })

    countryData.sort();

    return(
        <code>
            { JSON.stringify(countryData) }
        </code>
    )
}

export default CountryFlag;